define('glu/grid/cell/rowButtons',['require','../../itemView','../../$','../../util','../../$document','hbs!./rowButtons.hbs'],function(require) {
    'use strict';

    var ItemView = require('../../itemView'),
        $ = require('../../$'),
        util = require('../../util'),
        $document = require('../../$document'),
        tpl = require('hbs!./rowButtons.hbs'),
        $body = $('body');

    return ItemView.extend({
        template: tpl,

        events: {
            'click [data-index]': 'onClick',
            'click .dropdown-toggle': 'handleDropdownClick'
        },

        appEvents: {
            'grid:rowButtons:menuOpened': 'destroyPopup'
        },

        initialize: function() {
            this.prepareButtons();
            this.boundHandleDropdownClose = util.bind(this.handleDropdownClose, this);
            this.destroyOnScrollHandler = util.bind(this.destroyPopup, this);
            this.closeDropdown = util.bind(this.handleDropdownClosing, this);
        },

        attachDropdownEvents: function() {
            $body.on('keydown.grid.' + this.options.gridCid, this.boundHandleDropdownClose);
            $body.on('click.grid.' + this.options.gridCid, this.closeDropdown);
            $document.on('scroll.grid.' + this.options.gridCid, this.destroyOnScrollHandler);
        },

        detachDropdownEvents: function() {
            $document.off('scroll.grid.' + this.options.gridCid, this.destroyOnScrollHandler);
            $body.off('keydown.grid.' + this.options.gridCid, this.boundHandleDropdownClose);
            $body.off('click.grid.' + this.options.gridCid, this.closeDropdown);

            if (!this.$dropdownItems) {
                return;
            }

            this.$dropdownItems.off('click');
        },

        onClose: function() {
            this.destroyPopup();
            this.detachDropdownEvents();
        },

        handleDropdownClose: function(e) {
            if (!this.secondaryButtons.length || !this.$('.dropdown-menu').data('opened')) {
                return;
            }

            var keyCode = $.ui.keyCode; // eslint-disable-line backbone/no-native-jquery

            if (e.keyCode === keyCode.ESCAPE) {
                this.destroyPopup();
                this.$('.dropdown-toggle').focus();
            }

            if (e.keyCode === keyCode.TAB) {
                var $el = $document.find(e.target),
                    $parent = $el.closest('.dropdown-menu'),
                    $items = $parent.find('a'),
                    linkIndex = $items.index($el),
                    $firstLink = $items.first(),
                    $lastLink = $items.last();

                if (e.shiftKey) {
                    if (linkIndex === $items.index($firstLink)) {
                        $lastLink.focus();
                        e.preventDefault();
                    }
                } else {
                    if (linkIndex === $items.index($lastLink)) {
                        $firstLink.focus();
                        e.preventDefault();
                    }
                }
            }
        },

        handleDropdownClosing: function(e) {
            var $el = this.$(e.currentTarget);

            if ($el.is(this.$('.dropdown-toggle')) && $el.closest('.btn-group').length) {
                return;
            }

            this.destroyPopup();
        },

        prepareButtons: function() {
            var actions = this.options.column.get('rowButtons');
            if (actions && util.isFunction(actions.on)) {
                this.listenTo(actions, 'change', function() {
                    this.doPrepareButtons();
                    this.render();
                });
            }
            this.doPrepareButtons();
        },

        doPrepareButtons: function() {
            var actions = this.options.column.get('rowButtons');

            var finalActions = null;
            if (util.isArray(actions)) {
                finalActions = actions;
            } else if (util.isFunction(actions)) {
                finalActions = actions(this.model);
            }

            this.rowButtons = util.filter(finalActions, function(btn) {
                return !btn.bulkActionOnly && !(util.isFunction(btn.condition) && !btn.condition(this.model));
            }, this);
            this.primaryButton = this.rowButtons[0];
            this.secondaryButtons = util.rest(this.rowButtons);
        },

        templateHelpers: function() {
            return {
                primaryButton: this.primaryButton,
                secondaryButtons: this.secondaryButtons,
                cid: this.model.cid
            };
        },

        destroyPopup: function() {
            var $openedMenu = $body.find('> .dropdown-menu'),
                $initialMenu = $document.find('[data-id="' + $openedMenu.attr('id') + '"]');

            this.detachDropdownEvents();

            $initialMenu
                .attr('aria-expanded', false)
                .attr('id', $initialMenu.attr('data-id'))
                .removeAttr('data-id')
                .data('opened', false);

            this.$('.btn-group').removeClass('dropup');
            $openedMenu.remove();
        },

        onClick: function(e) {
            e.preventDefault();

            // Use $document because the dropdown is positioned on the body.
            var buttonIndex = $document.find(e.currentTarget).data('index') + 1,
                handler = this.rowButtons[buttonIndex].handler;

            handler.apply(this, [e, this.model]);
        },

        handleDropdownClick: function(e) {
            e.stopPropagation();
            e.preventDefault();

            var $menu = this.$('.dropdown-menu');

            if ($menu.data('opened')) {
                // user clicks dropdown button twice
                return this.destroyPopup();
            }

            this.appBus.trigger('grid:rowButtons:menuOpened');

            this.attachDropdownEvents();

            var $el = this.$(e.currentTarget),
                $menuClone = $menu.clone(false),
                id = $menu.attr('id');

            this.$dropdownItems = $menuClone.find('[data-index]');

            this.$dropdownItems.on('click', util.bind(function() {
                this.onClick.apply(this, arguments);
                this.destroyPopup();
            }, this));

            this.$('.dropdown-toggle').attr('aria-expanded', true);
            $menu.data('opened', true);
            $menu.removeAttr('id').attr('data-id', id);
            $menuClone.attr('id', id).appendTo($body);

            this.setPopupPosition($el, $menuClone);

            this.$dropdownItems.first().focus();
        },

        setPopupPosition: function($el, $menuClone) {
            var $group = this.$('.js-primary-row-action'),
                offset = $el.offset(),
                horizontalPosition = offset.left - $group.outerWidth(),
                verticalPosition = offset.top + $el.height(),
                documentHeight = $body.outerHeight(),
                popupHeight = $menuClone.outerHeight();

            if (documentHeight < (verticalPosition + popupHeight)) {
                verticalPosition -= (popupHeight + $group.outerHeight());
                this.$('.btn-group').addClass('dropup');
            }

            $menuClone.css({
                left: horizontalPosition,
                top: verticalPosition,
                display: 'block'
            });
        }
    });
});

